import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const KinKeeperLogin = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("auth");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(`${config.API_BASE_URL}/kinkeeper/login`, {
        email,
        password
      });

      const kinkeeperID = res.data.kinkeeperID;
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("kinkeeperID", kinkeeperID);

      const patientsRes = await axios.get(`${config.API_BASE_URL}/patients`, {
        params: { kinkeeperID }
      });

      const patients = patientsRes.data.patients;
      navigate(!patients || patients.length === 0 ? "/elders/new" : "/elders");
    } catch (err) {
      setError(err.response?.data?.error || t("kinKeeperLogin.failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-shell">
      <section className="page-panel">
        <div className="page-content auth-layout">
          <div className="support-card">
            <div>
              <div className="intro-badge">{t("kinKeeperLogin.badge")}</div>
              <h1 className="page-title">{t("kinKeeperLogin.title")}</h1>
              <p className="page-subtitle">
                {t("kinKeeperLogin.subtitle")}
              </p>
            </div>

            <div className="support-list">
              <div className="support-item">
                <span className="support-dot" />
                <div>
                  <div className="mini-label">{t("kinKeeperLogin.support1Title")}</div>
                  <p>{t("kinKeeperLogin.support1Text")}</p>
                </div>
              </div>
              <div className="support-item">
                <span className="support-dot" />
                <div>
                  <div className="mini-label">{t("kinKeeperLogin.support2Title")}</div>
                  <p>{t("kinKeeperLogin.support2Text")}</p>
                </div>
              </div>
              <div className="support-item">
                <span className="support-dot" />
                <div>
                  <div className="mini-label">{t("kinKeeperLogin.support3Title")}</div>
                  <p>{t("kinKeeperLogin.support3Text")}</p>
                </div>
              </div>
            </div>
          </div>

          <form className="form-card" onSubmit={handleLogin}>
            <div className="form-header">
              <h2>{t("kinKeeperLogin.formTitle")}</h2>
              <p>{t("kinKeeperLogin.formSubtitle")}</p>
            </div>

            {error && <div className="error-banner">{error}</div>}

            <div className="form-grid">
              <div className="form-field full">
                <label htmlFor="kinkeeper-email">{t("kinKeeperLogin.emailLabel")}</label>
                <input
                  id="kinkeeper-email"
                  className="text-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t("kinKeeperLogin.emailPlaceholder")}
                />
              </div>

              <div className="form-field full">
                <label htmlFor="kinkeeper-password">{t("kinKeeperLogin.passwordLabel")}</label>
                <div style={{ position: "relative" }}>
                  <input
                    id="kinkeeper-password"
                    className="text-input"
                    type={showPassword ? "text" : "password"}
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder={t("kinKeeperLogin.passwordPlaceholder")}
                    style={{ paddingRight: "3.5rem" }}
                  />
                  <button
                    type="button"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "0.9rem",
                      top: "50%",
                      transform: "translateY(-50%)",
                      border: "none",
                      background: "transparent",
                      color: "#5f6c76",
                      minHeight: "auto",
                      padding: 0
                    }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>
            </div>

            <div className="button-row">
              <button className="button" type="submit" disabled={loading}>
                {loading ? t("kinKeeperLogin.submitting") : t("kinKeeperLogin.submit")}
              </button>
            </div>

            <p className="simple-note">
              {t("kinKeeperLogin.noAccount")}{" "}
              <button
                type="button"
                className="simple-link"
                style={{ border: "none", background: "transparent", padding: 0 }}
                onClick={() => navigate("/register")}
              >
                {t("kinKeeperLogin.registerLink")}
              </button>
            </p>
          </form>
        </div>
      </section>
    </div>
  );
};

export default KinKeeperLogin;
